import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers/rootReducer';

export default function createAFLStore(initialState = {}) {
	return createStore(rootReducer, initialState, applyMiddleware(thunk));
}
